import { getDatabase, onChildAdded, ref } from "firebase/database"
import { useEffect } from "react"
import { Outlet } from "react-router"
import { toast } from "react-toastify"

import AdvertisementBanner from "@/components/AdvertisementBanner/AdvertisementBanner"
import AdvertisementModal from "@/components/AdvertisementModal/AdvertisementModal"
import BirthdayBanner from "@/components/BirthdayBanner/BirthdayBanner"
import MyModal from "@/components/MyModal/MyModal"
import SideBar from "@/components/SideBar/SideBar"
import app from "@/config/firebaseConfig"
import CourseModals from "@/features/pages/Courses/CourseModals"
import EnrolledCoursesModals from "@/features/pages/EnrolledCourses/EnrolledCoursesModals"
import FreeMaterialsModals from "@/features/pages/FreeMaterials/FreeMaterialsModals"
import FeedbackModals from "@/features/pages/Home/Feedback/FeedbackModals"
import ProjectsModals from "@/features/pages/Projects/ProjectsModals"
import TicketsModals from "@/features/pages/Tickets/TicketsModals"
import ShowText from "@/features/utils/ShowText"
import useServerPing from "@/hooks/useServerPing"
import { useSettingsData } from "@/queries/queries"
import { useStore } from "@/zustand/store"

export default function MainLayout() {
  const {
    sideBarOpen,
    setPrimaryColor,
    setSecondaryColor,
    setBrandingAssets,
    authData,
  } = useStore((state) => state)
  const settingsQuery = useSettingsData()

  // ping the server once every 30 seconds to keep the connection alive
  useServerPing()

  useEffect(() => {
    if (settingsQuery.data && Array.isArray(settingsQuery.data)) {
      const primaryColor = settingsQuery.data.find(
        (item) => item.key === "primary_color"
      )!.value
      const secondaryColor = settingsQuery.data.find(
        (item) => item.key === "secondary_color"
      )!.value

      setPrimaryColor(primaryColor)
      setSecondaryColor(secondaryColor)

      const siteLogo =
        settingsQuery.data.find((item) => item.key === "site_logo")?.value || ""
      const favicon =
        settingsQuery.data.find((item) => item.key === "site_favicon")?.value ||
        ""
      const loginLogo =
        settingsQuery.data.find((item) => item.key === "login_logo")?.value ||
        ""
      const siteTitle =
        settingsQuery.data.find((item) => item.key === "site_name")?.value || ""

      setBrandingAssets({ siteLogo, favicon, loginLogo, siteTitle })
    }
  }, [
    settingsQuery.data,
    setPrimaryColor,
    setSecondaryColor,
    setBrandingAssets,
  ])

  // 📢 Firebase listener for new data
  useEffect(() => {
    const db = getDatabase(app)
    const userId = authData?.user?.id
    const notificationsRef = ref(db, `user_notifications/${userId}`)

    const openTime = Math.floor(Date.now() / 1000) // وقت فتح الصفحة بالثواني

    const unsubscribe = onChildAdded(notificationsRef, (snapshot) => {
      const newData = snapshot.val()

      // نتأكد إنه أحدث من وقت فتح الصفحة
      if (newData?.created_at && newData.created_at > openTime) {
        toast.info(
          `📢 New Notification: ${newData?.title || "You have a new update"}`
        )
      }
    })

    return () => {
      unsubscribe()
    }
  }, [])

  return (
    // <div className="d-flex flex-row-reverse ramadan-bg-white">
    <div className="d-flex flex-row-reverse">
      <div
        className={`page-wrapper ${!sideBarOpen ? "sidebar--opened" : "sidebar--close"}`}
      >
        <BirthdayBanner />
        <AdvertisementBanner />
        <Outlet />
      </div>

      <SideBar />
      <CourseModals />
      <EnrolledCoursesModals />
      <FeedbackModals />
      <TicketsModals />
      <ProjectsModals />
      <AdvertisementModal />
      <FreeMaterialsModals />

      <MyModal size="lg" modalName="showText" title="Ticket Description">
        <ShowText />
      </MyModal>
    </div>
  )
}
